// dashbaord
import Default from "../Components/Dashboard/Default";
// //widgets
import Chart from "../Components/Widgets/Chart";
import General from "../Components/Widgets/General";

// //page-layout
// import FooterLight from '../Components/PageLayout/FooterLight';

// import FooterDark from '../Components/PageLayout/FooterDark';
// //ui-kits
// //Bonus-ui
// // Icons
// // Buttons
// //chart
// //forms
import FormValidation from "../Components/Forms/FormControl/FormValidation";
import BaseInput from "../Components/Forms/FormControl/BaseInput";
import CheckboxandRadio from "../Components/Forms/FormControl/CheckRadio";
import InputGroups from "../Components/Forms/FormControl/InputGroups";
import MegaOption from "../Components/Forms/FormControl/MegaOption";
import Datepicker from "../Components/Forms/FormWidget/DatePicker";
import TypeaheadComp from "../Components/Forms/FormWidget/TypeaheadComponent/Typeahead";
import FormDefault from "../Components/Forms/FormLayout/Default";
import FormWizard from "../Components/Forms/FormLayout/FormWizard1/FormWizard1";
import BasicTables from "../Components/Tables/Reactstrap/BasicTable";

import DataTables from "../Components/Tables/DataTable";

// //Application
// //Gallary
// //Blog
// //Pages
import SamplePage from "../Components/Pages/Sample";
// // import SearchPage from '../Components/Application/SearchResult'

// //Book mark
// //User app
// //social app
// //calender
// import CalenderContain from '../Components/Application/Calender/Index';

// //Email
// //File Manager
// //E-commerce
// //Job Search
// //Learning
// //Map
// //Editor
import DateTimeContain from "../Components/Forms/FormWidget/DateandTime";
import FormDateRangepickerContain from "../Components/Forms/FormWidget/FormDateRangePicker";
import FormSelectContain from "../Components/Forms/FormWidget/FormSelect2";
import FormSwitchContain from "../Components/Forms/FormWidget/FormSwitch";
import FormTouchspinContain from "../Components/Forms/FormWidget/FormTouchspin";
import FormClipboardContain from "../Components/Forms/FormWidget/FormClipboard";
//Dashboard Super admin
import DashboardSAdmin from "../Components/ControlPanel/Dashboard/Default";

//Admin Dashboard
import DashboardAdmin from "../Components/Admin/Dashboard/Default";
import TrafficDashboard from "../Components/Admin/Dashboard/Traffic";

//Concessionaire
import AddNewConcessionaire from "../Components/ControlPanel/Concessionaire/AddNewConcessionaire";
import ConcessionaireList from "../Components/ControlPanel/Concessionaire/ConcessionaireList";
import ViewConcessionaire from "../Components/ControlPanel/Concessionaire/ConcessionaireDetail";
import EditConcessionaire from "../Components/ControlPanel/Concessionaire/EditConcessionaire";

//Sadmin settings
import SadminUsers from "../Components/ControlPanel/Settings/Users";
import SadminLog from "../Components/ControlPanel/Settings/Log";
import ErrorLog from "../Components/ControlPanel/Settings/ErrorLogs";
import DeletionLog from "../Components/ControlPanel/Settings/DeletionLog";

//Backend User
import BackendUserHome from "../Components/BackendUser/Home";
import ViewAPIKey from "../Components/BackendUser/VIewAPIKey";
import DataDelete from "../Components/BackendUser/DeleteData";

// Country / Property / Category / Subcategory pages were folded into
// SettingsHub (see /admin/settings in this file). The legacy modules are
// kept on disk for one release cycle for safe rollback; the routes that
// previously rendered them now mount SettingsHub which redirects to the
// canonical /admin/settings?tab=…&action=… URL.

//Tenant
import ViewTenant from "../Components/Admin/Tenant/ViewTenant";
import TenantDetail from "../Components/Admin/Tenant/TenantDetail";
import EditTenant from "../Components/Admin/Tenant/EditTenant";
import AddNewTenant from "../Components/Admin/Tenant/AddTenant/AddNewTenant";
import TenantStatusChange from "../Components/Admin/Tenant/TenantStatus";
import EditLease from "../Components/Admin/Tenant/EditLease";

//Coonfigurations
import Configurations from "../Components/Admin/Configuration";


//Reports
import DaywiseReport from "../Components/Admin/Reports/DaywiseReport";
import MTDReport from "../Components/Admin/Reports/MTDReport";
import DaywiseConsolidated from "../Components/Admin/Reports/DaywiseConsolidated";
import RevenueShareReport from "../Components/Admin/Reports/RevenueShareReport";
import TradingDensityReport from "../Components/Admin/Reports/TradingDensityReport";
import DailyComprehensiveReport from "../Components/Admin/Reports/DailyComprehensiveReport";
import GrowthAnalysisReport from "../Components/Admin/Reports/GrowthAnalysisReport";
import DeliveryPartnerReport from "../Components/Admin/Reports/DeliveryPartnerReport";
import FbSalesSummary from "../Components/Admin/Reports/FBSalesSummary";
import MissingDatesReport from "../Components/Admin/Reports/MissingDatesReport";
import MonthwiseSalesReport from "../Components/Admin/Reports/MonthwiseSalesReport";
import AdditionalSalesSummary from "../Components/Admin/Reports/AdditionalSalesSummaryReport";

//More Reports
import ItemwiseReport from "../Components/Admin/Reports/ItemWiseReport";
import TenantAuditReport from "../Components/Admin/Reports/MoreReports/TenantAuditReport";
import InvoicewiseSalesReport from "../Components/Admin/Reports/MoreReports/InvoicewiseSalesReport";
import HourlySalesReport from "../Components/Admin/Reports/MoreReports/HourlySalesReport";
import TenantItemwiseReport from "../Components/Admin/Reports/MoreReports/TenantItemwiseReport";
import ConsolidatedDaywiseReport from "../Components/Admin/Reports/MoreReports/ConsolidatedDaywiseReport";
import TimeSeriesTrendChartReport from "../Components/Admin/Reports/MoreReports/TimeSeriesTrendChartReport";
import MonthlySalesTrendReport from "../Components/Admin/Reports/MoreReports/MonthlySalesTrendReport";
import DaywiseSalesTrendReport from "../Components/Admin/Reports/MoreReports/DaywiseSalesTrendReport";

//Data Grid
import DataGrid from "../Components/Admin/DataGrid";

//Admin Settings
import UserManagement from "../Components/Admin/AdminSettings/UserManagement";
import Log from '../Components/Admin/AdminSettings/Log'
import TenantPortal from "../Components/Admin/AdminSettings/TenantPortal";
import HealthCheckup from "../Components/Admin/AdminSettings/LiveHealthCheckup/HealthCheckup";

//Dynamic Reports
import DynamicReports from "../Components/Admin/DynamicReports";
import RunReport from "../Components/Admin/DynamicReports/RunReport";
import ScheduleReport from "../Components/Admin/ScheduleReport";

//change password
import ChangePassword from "../Auth/ChangePassword";

//Tenant login
import TenantHome from "../Components/Tenant/Home";
import ApiKey from "../Components/Tenant/APIKey";

//Audit
import Audit from "../Components/Admin/Audit/Dashboard";
import UploadMonthlySales from "../Components/Admin/Audit/UploadSales";
import TenantAudit from "../Components/Admin/Audit/TenantAudit";
import Reconciliation from "../Components/Admin/Audit/Reconciliation";

//License Inventory
import LicensesAdminPage from "../Components/Admin/Licenses";
import LicensesBackendUserPage from "../Components/BackendUser/Licenses";

// V3 Sprint 2 pages
import SpatialLandingPage from "../Components/V3/SpatialLanding/SpatialLandingPage";
import WidgetGrid from "../Components/V3/Widgets/WidgetGrid";
import { DashboardFiltersProvider } from "../Components/V3/Widgets/filters/DashboardFiltersProvider";
import V3TenantDashboardPage from "../Components/V3/TenantDashboard/V3TenantDashboardPage";
import ComparisonTool from "../Components/V3/Analytics/ComparisonTool";
import CommandCenter from "../Components/V3/CommandCenter/CommandCenter";
import SeasonalLandingPage from "../Components/V3/Seasonal/SeasonalLandingPage";
import AnomaliesPage from "../Components/V3/Anomalies/AnomaliesPage";
import AnalyticsPage from "../Components/V3/AnalyticsPro/AnalyticsPage";
import TwinPage from "../Components/V3/DigitalTwin/TwinPage";
import MallMapPage from "../Components/V3/MallMap/MallMapPage";
import PlanImporter from "../Components/V3/MallMap/Importer/PlanImporter";
import RequireAccess from "./RequireAccess";
import { canViewDigitalTwin, canImportFloorPlan } from "../Components/V3/hooks/useAuth";

// Operations — Work Permit / NOC (ported from V2, secure V3 rebuild)
import WorkPermitApprovals from "../Components/V3/Operations/WorkPermit/WorkPermitApprovals";
import WorkPermitApply from "../Components/V3/Operations/WorkPermit/WorkPermitApply";
import WorkPermitConfig from "../Components/V3/Operations/WorkPermit/WorkPermitConfig";
import InvoiceList from "../Components/V3/Invoicing/InvoiceList";
import InvoiceGenerate from "../Components/V3/Invoicing/InvoiceGenerate";
import InvoiceDetail from "../Components/V3/Invoicing/InvoiceDetail";
import InvoiceSettings from "../Components/V3/Invoicing/InvoiceSettings";

// Settings hub (Sprint 3.5 — General Settings v3 migration)
import SettingsHub from "../Components/Admin/Settings/SettingsHub";

export const routes = [
  { path: `${process.env.PUBLIC_URL}/dashboard/default/:layout`, Component: <Default /> },

  { path: `${process.env.PUBLIC_URL}/widgets/general/:layout`, Component: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart/:layout`, Component: <Chart /> },

  { path: `${process.env.PUBLIC_URL}/forms/controls/validation/:layout`, Component: <FormValidation /> },
  { path: `${process.env.PUBLIC_URL}/forms/controls/input/:layout`, Component: <BaseInput /> },
  { path: `${process.env.PUBLIC_URL}/forms/controls/radio-checkbox/:layout`, Component: <CheckboxandRadio /> },
  { path: `${process.env.PUBLIC_URL}/forms/controls/group/:layout`, Component: <InputGroups /> },
  { path: `${process.env.PUBLIC_URL}/forms/controls/megaoption/:layout`, Component: <MegaOption /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/datepicker/:layout`, Component: <Datepicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/typeahead/:layout`, Component: <TypeaheadComp /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/datetimepicker/:layout`, Component: <DateTimeContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/rangepicker/:layout`, Component: <FormDateRangepickerContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/select2/:layout`, Component: <FormSelectContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/switch/:layout`, Component: <FormSwitchContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/touchspin/:layout`, Component: <FormTouchspinContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/clipboard/:layout`, Component: <FormClipboardContain /> },

  { path: `${process.env.PUBLIC_URL}/forms/layout/formDefault/:layout`, Component: <FormDefault /> },
  { path: `${process.env.PUBLIC_URL}/forms/layout/formWizard/:layout`, Component: <FormWizard /> },

  // //Tables
  { path: `${process.env.PUBLIC_URL}/table/reactstraptable/basictable/:layout`, Component: <BasicTables /> },
  { path: `${process.env.PUBLIC_URL}/table/datatable/:layout`, Component: <DataTables /> },

  // //Applicatiion

  // //Gallery

  // //page
  { path: `${process.env.PUBLIC_URL}/pages/sample-page/:layout`, Component: <SamplePage /> },

  // //Blog

  // //Job Search

  // //Learning

  // //Map

  // //Editor

  // //Knowledge

  // //Support Ticket

  // //Faq

  //Dashboard Admin
  { path: `${process.env.PUBLIC_URL}/admin/dashboard/sales/:layout`, Component: <DashboardAdmin /> },
  { path: `${process.env.PUBLIC_URL}/admin/dashboard/traffic/:layout`, Component: <TrafficDashboard /> },

  //Dashboard Super Admin
  { path: `${process.env.PUBLIC_URL}/controlpanel/dashboard/default/:layout`, Component: <DashboardSAdmin /> },

  //Concessionaire
  { path: `${process.env.PUBLIC_URL}/controlpanel/concessionaire/addnewconcessionaire/:layout`, Component: <AddNewConcessionaire /> },
  { path: `${process.env.PUBLIC_URL}/controlpanel/concessionaire/viewconcessionaire/:layout`, Component: <ConcessionaireList /> },
  { path: `${process.env.PUBLIC_URL}/controlpanel/concessionaire/viewconcessionairedetail/:id`, Component: <ViewConcessionaire /> },
  { path: `${process.env.PUBLIC_URL}/controlpanel/concessionaire/editconcessionaire/:id`, Component: <EditConcessionaire /> },

  //Sadmin Settings
  { path: `${process.env.PUBLIC_URL}/controlpanel/users/:layout`, Component: <SadminUsers /> },
  { path: `${process.env.PUBLIC_URL}/controlpanel/log/:layout`, Component: <SadminLog /> },
  { path: `${process.env.PUBLIC_URL}/controlpanel/errorlog/:layout`, Component: <ErrorLog /> },
  { path: `${process.env.PUBLIC_URL}/controlpanel/deletionLog/:layout`, Component: <DeletionLog /> },

  //Backend User
  { path: `${process.env.PUBLIC_URL}/admin/home/:layout`, Component: <BackendUserHome /> },
  { path: `${process.env.PUBLIC_URL}/admin/viewapikey/:layout`, Component: <ViewAPIKey /> },
  { path: `${process.env.PUBLIC_URL}/admin/deletedata/:layout`, Component: <DataDelete /> },

  // ── General Settings hub (v3 migration, Sprint 3.5) ──────────────────────
  // The hub absorbs the old Country / Property / Category / Subcategory pages.
  // The same component handles the legacy URLs below by reading useParams() —
  // it rewrites the location to /admin/settings?tab=…&action=… so bookmarks
  // and any external links keep working.
  { path: `${process.env.PUBLIC_URL}/admin/settings`, Component: <SettingsHub /> },
  // Sidebar links append "/<layoutId>" to every menu path (see
  // SidebarMenuItems.jsx). Catch that trailing segment so the link still
  // resolves to the hub.
  { path: `${process.env.PUBLIC_URL}/admin/settings/:layout`, Component: <SettingsHub /> },

  // Legacy aliases — all funnel into SettingsHub. The hub reads useParams(),
  // detects the entity + op, and rewrites the location to
  // /admin/settings?tab=…&action=… so bookmarks keep working.
  // Each entity gets explicit list/add/edit aliases instead of a catch-all
  // so unrelated /admin/<other>/<op>/<id> routes (audit, datagrid, etc.)
  // are not accidentally captured.
  { path: `${process.env.PUBLIC_URL}/admin/country/viewcountry/:layout`, Component: <SettingsHub /> },
  { path: `${process.env.PUBLIC_URL}/admin/country/addcountry/:layout`, Component: <SettingsHub /> },
  { path: `${process.env.PUBLIC_URL}/admin/country/editcountry/:id`, Component: <SettingsHub /> },
  { path: `${process.env.PUBLIC_URL}/admin/country/countrydetail/:id`, Component: <SettingsHub /> },

  { path: `${process.env.PUBLIC_URL}/admin/property/viewproperty/:layout`, Component: <SettingsHub /> },
  { path: `${process.env.PUBLIC_URL}/admin/property/addproperty/:layout`, Component: <SettingsHub /> },
  { path: `${process.env.PUBLIC_URL}/admin/property/editproperty/:id`, Component: <SettingsHub /> },
  { path: `${process.env.PUBLIC_URL}/admin/property/propertydetail/:id`, Component: <SettingsHub /> },

  { path: `${process.env.PUBLIC_URL}/admin/category/viewcategory/:layout`, Component: <SettingsHub /> },
  { path: `${process.env.PUBLIC_URL}/admin/category/addcategory/:layout`, Component: <SettingsHub /> },
  { path: `${process.env.PUBLIC_URL}/admin/category/editcategory/:id`, Component: <SettingsHub /> },

  { path: `${process.env.PUBLIC_URL}/admin/subcategory/viewsubcategory/:layout`, Component: <SettingsHub /> },
  { path: `${process.env.PUBLIC_URL}/admin/subcategory/addsubcategory/:layout`, Component: <SettingsHub /> },
  { path: `${process.env.PUBLIC_URL}/admin/subcategory/editsubcategory/:id`, Component: <SettingsHub /> },

  //Tenant

  //Tenant
  { path: `${process.env.PUBLIC_URL}/admin/tenant/newtenant/:layout`, Component: <AddNewTenant /> },
  { path: `${process.env.PUBLIC_URL}/admin/tenant/viewtenant/:layout`, Component: <ViewTenant /> },
  { path: `${process.env.PUBLIC_URL}/admin/tenant/tenantdetail/:id`, Component: <TenantDetail /> },
  { path: `${process.env.PUBLIC_URL}/admin/tenant/tenantedit/:id`, Component: <EditTenant /> },
  { path: `${process.env.PUBLIC_URL}/admin/tenant/tenantstatuschange/:id`, Component: <TenantStatusChange /> },
  { path: `${process.env.PUBLIC_URL}/admin/tenant/leaseedit/:id`, Component: <EditLease /> },

  //Configurations

  { path: `${process.env.PUBLIC_URL}/admin/configurations/:layout`, Component: <Configurations /> },

  //Reports
  { path: `${process.env.PUBLIC_URL}/admin/report/daywisereport/:layout`, Component: <DaywiseReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/mtdreport/:layout`, Component: <MTDReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/daywiseconsolidated/:layout`, Component: <DaywiseConsolidated /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/revenuesharereport/:layout`, Component: <RevenueShareReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/tradingdensityreport/:layout`, Component: <TradingDensityReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/dailycomprehensiverevenue/:layout`, Component: <DailyComprehensiveReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/growthanalysisreport/:layout`, Component: <GrowthAnalysisReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/deliverypartnerreport/:layout`, Component: <DeliveryPartnerReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/fbsalessummary/:layout`, Component: <FbSalesSummary /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/missingdates/:layout`, Component: <MissingDatesReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/monthwisesales/:layout`, Component: <MonthwiseSalesReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/additionalsalessummary/:layout`, Component: <AdditionalSalesSummary /> },

  //More Reports
  { path: `${process.env.PUBLIC_URL}/admin/report/itemwisereport/:layout`, Component: <ItemwiseReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/tenantauditreport/:layout`, Component: <TenantAuditReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/invoicewisesalesreport/:layout`, Component: <InvoicewiseSalesReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/hourlysalesreport/:layout`, Component: <HourlySalesReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/tenantitemwisesales/:layout`, Component: <TenantItemwiseReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/consolidateddaywisereport/:layout`, Component: <ConsolidatedDaywiseReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/timeseriestrendchartreport/:layout`, Component: <TimeSeriesTrendChartReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/monthlysalestrendreport/:layout`, Component: <MonthlySalesTrendReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/report/daywisesalestrendreport/:layout`, Component: <DaywiseSalesTrendReport /> },

  //Data Grid
  { path: `${process.env.PUBLIC_URL}/admin/datagrid/:layout`, Component: <DataGrid /> },

  //Admin settings
  { path: `${process.env.PUBLIC_URL}/admin/usermanagement/:layout`, Component: <UserManagement /> },
  { path: `${process.env.PUBLIC_URL}/admin/logs/:layout`, Component: <Log /> },
  { path: `${process.env.PUBLIC_URL}/admin/tenantportal/:layout`, Component: <TenantPortal /> },
  { path: `${process.env.PUBLIC_URL}/admin/healthcheckup/:layout`, Component: <HealthCheckup /> },

  //Dynamic Reports
  { path: `${process.env.PUBLIC_URL}/admin/dynamicreports/:layout`, Component: <DynamicReports /> },
  { path: `${process.env.PUBLIC_URL}/admin/runreport/:id`, Component: <RunReport /> },
  { path: `${process.env.PUBLIC_URL}/admin/schedulereports/:layout`, Component: <ScheduleReport /> },

  //change Password
  { path: `${process.env.PUBLIC_URL}/account/changepassword/:layout`, Component: <ChangePassword /> },

  //Tenant Login
  { path: `${process.env.PUBLIC_URL}/tenant/home/:layout`, Component: <TenantHome /> },
  { path: `${process.env.PUBLIC_URL}/tenant/apikey/generateapikey/:layout`, Component: <ApiKey /> },

  //Audit
  { path: `${process.env.PUBLIC_URL}/admin/audit/:layout`, Component: <Audit /> },
  { path: `${process.env.PUBLIC_URL}/admin/audit/uploadmonthlysales/:layout`, Component: <UploadMonthlySales /> },
  { path: `${process.env.PUBLIC_URL}/admin/audit/tenant/:id`, Component: <TenantAudit /> },
  { path: `${process.env.PUBLIC_URL}/admin/audit/reconciliation/:id`, Component: <Reconciliation /> },

  //License Inventory
  { path: `${process.env.PUBLIC_URL}/admin/licenses/:layout`, Component: <LicensesAdminPage /> },
  { path: `${process.env.PUBLIC_URL}/admin/licenses/po/:layout`, Component: <LicensesAdminPage /> },
  { path: `${process.env.PUBLIC_URL}/backend/licenses/:layout`, Component: <LicensesBackendUserPage /> },

  // V3 Sprint 2 routes
  { path: `${process.env.PUBLIC_URL}/v3/spatial`, Component: <SpatialLandingPage /> },
  { path: `${process.env.PUBLIC_URL}/v3/dashboard`, Component: <DashboardFiltersProvider><WidgetGrid /></DashboardFiltersProvider> },
  { path: `${process.env.PUBLIC_URL}/v3/dashboard/:layoutKey`, Component: <DashboardFiltersProvider><WidgetGrid /></DashboardFiltersProvider> },
  { path: `${process.env.PUBLIC_URL}/v3/tenant`, Component: <DashboardFiltersProvider layoutKey="tenant"><V3TenantDashboardPage /></DashboardFiltersProvider> },
  { path: `${process.env.PUBLIC_URL}/v3/compare`, Component: <ComparisonTool /> },
  { path: `${process.env.PUBLIC_URL}/v3/command`, Component: <CommandCenter /> },
  { path: `${process.env.PUBLIC_URL}/v3/anomalies`, Component: <AnomaliesPage /> },
  { path: `${process.env.PUBLIC_URL}/v3/seasonal`, Component: <SeasonalLandingPage /> },
  { path: `${process.env.PUBLIC_URL}/v3/analytics`, Component: <AnalyticsPage /> },
  { path: `${process.env.PUBLIC_URL}/v3/twin/:propertyId`, Component: <TwinPage /> },
  // Gated on the concessionaire-level entitlement, and the importer separately
  // from the view because it rewrites the published plan every other surface
  // reads. See Route/RequireAccess and hooks/useAuth.
  { path: `${process.env.PUBLIC_URL}/v3/mallmap`, Component: <RequireAccess allow={canViewDigitalTwin}><MallMapPage /></RequireAccess> },
  { path: `${process.env.PUBLIC_URL}/v3/mallmap/import`, Component: <RequireAccess allow={canImportFloorPlan}><PlanImporter /></RequireAccess> },

  // Operations — Work Permit / NOC. Static /apply + /config rank above the
  // catch-all :layout (which absorbs the trailing segment the sidebar appends).
  { path: `${process.env.PUBLIC_URL}/v3/operations/workpermit`, Component: <WorkPermitApprovals /> },
  { path: `${process.env.PUBLIC_URL}/v3/operations/workpermit/apply`, Component: <WorkPermitApply /> },
  { path: `${process.env.PUBLIC_URL}/v3/operations/workpermit/apply/:layout`, Component: <WorkPermitApply /> },
  { path: `${process.env.PUBLIC_URL}/v3/operations/workpermit/config`, Component: <WorkPermitConfig /> },
  { path: `${process.env.PUBLIC_URL}/v3/operations/workpermit/config/:layout`, Component: <WorkPermitConfig /> },
  { path: `${process.env.PUBLIC_URL}/v3/operations/workpermit/:layout`, Component: <WorkPermitApprovals /> },

  // Finance — Invoicing.
  //
  // Detail lives under an explicit /invoice/:id segment rather than a bare
  // /v3/invoicing/:id. V3Sidebar navigates /v3/* paths as-is, but MenuAdmin is
  // also consumed by the V2 sidebar, which appends the layout id — so a bare
  // /:id would swallow /v3/invoicing/default and render the detail page with
  // id='default'. A distinct segment removes the ambiguity entirely instead of
  // relying on declaration order.
  { path: `${process.env.PUBLIC_URL}/v3/invoicing`, Component: <InvoiceList /> },
  { path: `${process.env.PUBLIC_URL}/v3/invoicing/generate`, Component: <InvoiceGenerate /> },
  { path: `${process.env.PUBLIC_URL}/v3/invoicing/generate/:layout`, Component: <InvoiceGenerate /> },
  { path: `${process.env.PUBLIC_URL}/v3/invoicing/settings`, Component: <InvoiceSettings /> },
  { path: `${process.env.PUBLIC_URL}/v3/invoicing/settings/:layout`, Component: <InvoiceSettings /> },
  { path: `${process.env.PUBLIC_URL}/v3/invoicing/invoice/:id`, Component: <InvoiceDetail /> },
  { path: `${process.env.PUBLIC_URL}/v3/invoicing/:layout`, Component: <InvoiceList /> },

];
